import { render, staticRenderFns } from "./LIcon.vue?vue&type=template&id=b5cb1d22&scoped=true"
import script from "./LIcon.vue?vue&type=script&lang=ts"
export * from "./LIcon.vue?vue&type=script&lang=ts"
import style0 from "./LIcon.vue?vue&type=style&index=0&id=b5cb1d22&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cb1d22",
  null
  
)

export default component.exports